'use client';

import { Check } from 'iconoir-react';

import { Combobox as ChakraCombobox, Portal } from '@chakra-ui/react';
import * as React from 'react';
interface ComboboxContentProps extends ChakraCombobox.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
}

export const ComboboxContent = React.forwardRef<HTMLDivElement, ComboboxContentProps>(
  function ComboboxContent(props, ref) {
    const { portalled = true, portalRef, ...rest } = props;
    return (
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraCombobox.Positioner>
          <ChakraCombobox.Content ref={ref} {...rest} />
        </ChakraCombobox.Positioner>
      </Portal>
    );
  }
);

interface ComboboxItemProps extends ChakraCombobox.ItemProps {
  hideIndicator?: boolean;
}

export const ComboboxItem = React.forwardRef<HTMLDivElement, ComboboxItemProps>(
  function ComboboxItem(props, ref) {
    const { item, children, hideIndicator = false, ...rest } = props;
    return (
      <ChakraCombobox.Item key={item.value} item={item} ref={ref} {...rest}>
        {children}
        {!hideIndicator && (
          <ChakraCombobox.ItemIndicator>
            <Check />
          </ChakraCombobox.ItemIndicator>
        )}
      </ChakraCombobox.Item>
    );
  }
);

export const ComboboxItemGroup = React.forwardRef<HTMLDivElement, ChakraCombobox.ItemGroupProps>(
  function ComboboxItemGroup(props, ref) {
    const { title, children, ...rest } = props;
    return (
      <ChakraCombobox.ItemGroup ref={ref} {...rest}>
        {title && (
          <ChakraCombobox.ItemGroupLabel userSelect="none">{title}</ChakraCombobox.ItemGroupLabel>
        )}
        {children}
      </ChakraCombobox.ItemGroup>
    );
  }
);

export const ComboboxRoot = ChakraCombobox.Root;
export const ComboboxControl = ChakraCombobox.Control;
export const ComboboxInput = ChakraCombobox.Input;
export const ComboboxTrigger = ChakraCombobox.Trigger;
export const ComboboxIndicatorGroup = ChakraCombobox.IndicatorGroup;
export const ComboboxItemText = ChakraCombobox.ItemText;
export const ComboboxClearTrigger = ChakraCombobox.ClearTrigger;
